import React from 'react';
import Label from '../../../components/ui/Label/Label';
/**
 *
 */
export default function AssetLabelFilterItem(props) {
    var labelModel = props.labelModel, labelsFilter = props.labelsFilter, onClick = props.onClick;
    var labelId = encodeURIComponent('label-id-' + labelModel.name);
    var checked = false;
    if (labelsFilter.value != null) {
        checked = !!labelsFilter.value.find(function (val) {
            return labelModel.name === val;
        });
    }
    return React.createElement("li", null,
        React.createElement("div", { className: "dropdown-item d-flex", key: 'lbf-' + labelId, onClick: onClick, "data-value": labelModel.name, "data-checked": checked },
            React.createElement("div", { className: "custom-control custom-checkbox" },
                React.createElement("input", { ref: function (ref) {
                        if (ref) {
                            ref.checked = checked;
                        }
                    }, type: "checkbox", className: "custom-control-input", id: labelId, checked: checked, onChange: function () { }, value: labelModel.name }),
                React.createElement(Label, { className: "custom-control-label", model: labelModel, htmlFor: labelId }))));
}
AssetLabelFilterItem.defaultProps = {
    className: ''
};
